import React, { useEffect, useMemo, useState } from "react";
import styles from "./Product.module.css";

import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import GppBadOutlinedIcon from "@mui/icons-material/GppBadOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Loader from "../../Loader/Loader";
import { searchProducts, exportProductsCsv } from "../../service/Mainservice";
import ExportCsvButton from "../ExportCsvButton";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Pagination from "../Pagination/pagination";

const Products = () => {
  const [loading, setLoading] = useState(false);

  const [products, setProducts] = useState([]);

  const [pagination, setpagination] = useState({ page: 1 });

  const [filters, setFilters] = useState({
    search: "",
    categoryId: "",
    subcategoryId: "",
    availability: "",
    flagged: "",
    blocked: "",
    page: 1,
    limit: 10,
  });

  // Category list should come from your master API
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async (customFilters = filters) => {
    try {
      setLoading(true);

      const payload = {
        search: customFilters.search,
        categoryId: customFilters.categoryId || undefined,
        page: customFilters.page,
        limit: customFilters.limit,
      };

      const response = await searchProducts(payload);

      setProducts(response.data.data || []);

      setpagination(response?.data?.pagination || { page: 1 });

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const handleSearch = (e) => {
    const updated = {
      ...filters,
      search: e.target.value,
      page: 1,
    };

    setFilters(updated);
    getProducts(updated);
  };
  const handlePageChange = (page) => {
    const updated = {
      ...filters,
      page: page,
    };

    setFilters(updated);
    getProducts(updated);
  };
  const handleCategory = (e) => {
    const updated = {
      ...filters,
      categoryId: e.target.value,
      page: 1,
    };

    setFilters(updated);
    getProducts(updated);
  };

  const refreshData = () => {
    setFilters({
      search: "",
      categoryId: "",
      subcategoryId: "",
      availability: "",
      flagged: "",
      blocked: "",
      page: 1,
      limit: 10,
    });

    getProducts({
      search: "",
      categoryId: "",
      page: 1,
      limit: 10,
    });
  };

  const stats = useMemo(() => {
    return {
      total: products.length,

      available: products.filter((x) => x.availability === "Available").length,

      blocked: products.filter((x) => x.isBlocked).length,

      flagged: products.filter((x) => x.isFlagged).length,
    };
  }, [products]);
  return (
    <>
      {" "}
      {/* ================= STATS ================= */}
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={styles.statIcon}>
            <Inventory2OutlinedIcon />
          </div>

          <div>
            <span>Total Products</span>
            <h2>{stats.total}</h2>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={`${styles.statIcon} ${styles.green}`}>
            <VerifiedUserOutlinedIcon />
          </div>

          <div>
            <span>Available</span>
            <h2>{stats.available}</h2>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={`${styles.statIcon} ${styles.orange}`}>
            <GppBadOutlinedIcon />
          </div>

          <div>
            <span>Flagged</span>
            <h2>{stats.flagged}</h2>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={`${styles.statIcon} ${styles.red}`}>
            <StorefrontOutlinedIcon />
          </div>

          <div>
            <span>Blocked</span>
            <h2>{stats.blocked}</h2>
          </div>
        </div>
      </div>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Products</h1>
          <ExportCsvButton
            exportRequest={exportProductsCsv}
            filters={{
              search: filters.search,
              categoryId: filters.categoryId,
              subcategoryId: filters.subcategoryId,
              status: filters.blocked
                ? "blocked"
                : filters.flagged
                  ? "flagged"
                  : filters.availability,
            }}
            filename="products.csv"
          />
          <div className="searchicon">
            <SearchOutlinedIcon />
            <input
              type="search"
              placeholder="Search product name..."
              value={filters.search}
              onChange={handleSearch}
              autoComplete="off"
            />
          </div>
        </div>
        <div className="filters_row">
          <div className="filter_group">
            <select value={filters.categoryId} onChange={handleCategory}>
              <option value="">All Categories</option>

              {categories.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* ================= PRODUCT TABLE ================= */}

        <div className="data_table_over">
          <table className="data_table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Vendor</th>
                <th>Category</th>
                <th>Price</th>
                <th>Variants</th>
                <th>Availability</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {products.length > 0 ? (
                products.map((item) => (
                  <tr key={item.id}>
                    {/* ================= PRODUCT ================= */}

                    <td>
                      <div className={styles.productInfo}>
                        <img
                          src={
                            item.images?.length > 0 ? item.images[0].image : ""
                          }
                          alt={item.name}
                          className={styles.productImage}
                          onError={(e) => {
                            e.target.src = "";
                          }}
                        />

                        <div>
                          <h4>{item.name}</h4>

                          <p>
                            {item.about?.length > 70
                              ? item.about.substring(0, 70) + "..."
                              : item.about}
                          </p>
                        </div>
                      </div>
                    </td>

                    {/* ================= VENDOR ================= */}

                    <td>
                      <div className={styles.vendorInfo}>
                        <img
                          src={
                            item.vendor?.shopImage ||
                            "/images/store-placeholder.png"
                          }
                          alt={item.vendor?.shopName}
                          className={styles.vendorImage}
                          onError={(e) => {
                            e.target.src = "/images/store-placeholder.png";
                          }}
                        />

                        <div>
                          <h5>{item.vendor?.shopName}</h5>

                          <span>{item.vendor?.fullName}</span>

                          <small>{item.vendor?.email}</small>
                        </div>
                      </div>
                    </td>

                    {/* ================= CATEGORY ================= */}

                    <td>
                      <div className={styles.categoryInfo}>
                        <strong>{item.categoryName}</strong>
                      </div>
                    </td>

                    {/* ================= PRICE ================= */}

                    <td>
                      <div className={styles.priceBox}>
                        <strong>${item.price}</strong>
                      </div>
                    </td>

                    {/* ================= VARIANTS ================= */}

                    <td>
                      <div className={styles.variantBox}>
                        <strong>{item.variants?.length || 0}</strong>

                        {/* <span>Variants</span> */}
                      </div>
                    </td>

                    {/* ================= AVAILABILITY ================= */}

                    <td>
                      <div className={styles.availabilityBox}>
                        <small>
                          {item.availabilityStartTime} -{" "}
                          {item.availabilityEndTime}
                        </small>
                        <br />
                        <span
                          className={
                            item.availability === "Available"
                              ? styles.available
                              : styles.unavailable
                          }
                        >
                          {item.availability}
                        </span>
                      </div>
                    </td>

                    {/* ================= STATUS ================= */}

                    <td>
                      <div className={styles.statusGroup}>
                        {item.isBlocked ? (
                          <span
                            className={`${styles.statusBadge} ${styles.unavailable}`}
                          >
                            Blocked
                          </span>
                        ) : (
                          <span
                            className={`${styles.statusBadge} ${styles.available}`}
                          >
                            Active
                          </span>
                        )}

                        {item.isFlagged && (
                          <span
                            className={`${styles.statusBadge} ${styles.flagged}`}
                          >
                            Flagged
                          </span>
                        )}
                      </div>
                    </td>

                    {/* ================= ACTIONS ================= */}

                    <td>
                      <div className={styles.actionButtons}>
                        <RemoveRedEyeIcon
                          sx={{
                            color: "#3b82f6",
                            fontSize: "25px",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/product-details", {
                              state: {
                                item: item,
                              },
                            });
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">
                    <div className={styles.noData}>
                      <Inventory2OutlinedIcon size={50} />

                      <h3>No Products Found</h3>

                      <p>No products match the selected filters.</p>
                    </div>
                  </td>
                </tr>
              )}{" "}
            </tbody>
          </table>
        </div>
        <Pagination pagedata={pagination} onPageChange={handlePageChange} />
      </div>
      {loading && <Loader />}
    </>
  );
};

export default Products;
